import React from 'react';
import { Box, Grid, Skeleton, Stack } from '@mui/material';

function DashBoardLoading() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', xl: 'row' },
        gap: 4,
        p: 2
      }}
    >
      <Box sx={{ flex: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Grid container spacing={2}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Grid item xs={6} md={3} key={`benef-${i}`}>
              <Skeleton variant='rounded' height={150} />
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={2}>
          {Array.from({ length: 2 }).map((_, i) => (
            <Grid item xs={6} md={i == 0 ? 8 : 4} key={`preauth-${i}`}>
              <Skeleton variant='rounded' height={250} />
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={2}>
          {Array.from({ length: 2 }).map((_, i) => (
            <Grid item xs={6} md={6} key={`claim-${i}`}>
              <Skeleton variant='rounded' height={250} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default DashBoardLoading;
